import { gql } from '@apollo/client';
import type { InhubTransportDetailInput } from '../queries/getInhubTransportBagDetailPage';

// 仅用于本仓发出（OUTBOUND）视角，后端按 fromHubId 校验仓库权限
export const GENERATE_INHUB_TRANSPORT_BAG_DETAIL_EXPORT = gql`
  mutation GenerateInhubTransportBagDetailExport(
    $filter: InhubTransportDetailInput!
    $timezone: String
  ) {
    generateInhubTransportBagDetailExport(filter: $filter, timezone: $timezone)
  }
`;

// 本仓到达（INBOUND）视角专用，后端按 toHubId 校验仓库权限
export const GENERATE_INHUB_TRANSPORT_INBOUND_BAG_DETAIL_EXPORT = gql`
  mutation GenerateInhubTransportInboundBagDetailExport(
    $filter: InhubTransportDetailInput!
    $timezone: String
  ) {
    generateInhubTransportInboundBagDetailExport(filter: $filter, timezone: $timezone)
  }
`;

export interface GenerateInhubTransportBagDetailExportVariables {
    filter: InhubTransportDetailInput;
    timezone?: string;
}

// 两个视角各自独立的 operation，抽屉按当前视角二选一，故两个 key 均为可选
export interface GenerateInhubTransportBagDetailExportResponse {
    generateInhubTransportBagDetailExport?: string;
    generateInhubTransportInboundBagDetailExport?: string;
}
